import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { MediaImageModel } from '@modules/media/models/media-image.model';

@Component({
  selector: 'mb-contact-person-card',
  templateUrl: './contact-person-card.component.html',
  styleUrls: ['./contact-person-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactPersonCardComponent {
  @HostBinding('class.no-media')
  @Input()
  hideMedia = false;

  @Input() fullname!: string;
  @Input() position!: string;
  @Input() email?: string;
  @Input() phone?: string;
  @Input() media: MediaImageModel | undefined | null;
  @Input() initials!: string;
  @Input() topline?: string;
}
